export const ROW_GUTTER = 16;
export const SIDE_NAV_WIDTH = 220;
export const SIDE_NAV_LIGHT = 'SIDE_NAV_LIGHT';
export const SIDE_NAV_DARK = 'SIDE_NAV_DARK';
export const NAV_LOGO_WIDTH = 155;
export const DIR_LTR = 'ltr';
export const DIR_RTL = 'rtl';
